export interface Person {
  value: number;
  viewValue: string;
}

export const PERSONS: Person[] = [
  { value: 1, viewValue: '1 person' },
  { value: 2, viewValue: '2 personer' },
  { value: 3, viewValue: '3 personer' },
  { value: 4, viewValue: '4 personer' },
  { value: 5, viewValue: '5 personer' },
  { value: 6, viewValue: '6 personer' },
  { value: 7, viewValue: '7 personer' },
  { value: 8, viewValue: '8 personer' }
];
